import { setLocalStorageData } from "@Components/LeadFormModal/data/leadFormReducer";
import type { AppDispatch } from "@Store/index";
import setLeadPersonalDetails from "helpers/setPersonalDetailsLocalstorage";

interface SyncAppLeadPersonalDetailsArgs {
  dispatch: AppDispatch;
  isAmberApp: boolean;
  isUserLoggedIn: boolean;
  userData: any;
}

const syncAppLeadPersonalDetails = ({
  dispatch,
  isAmberApp,
  isUserLoggedIn,
  userData,
}: SyncAppLeadPersonalDetailsArgs) => {
  if (!isAmberApp || !isUserLoggedIn || !userData) return false;

  // /users/details is wrapped as { message, data } by the website API proxy.
  // The existing persistence helper expects the user fields themselves.
  const loggedInUser = { ...(userData.data ?? userData) };

  // Phone login creates a backend-only placeholder address. The website excludes it from
  // prefill, so clear it before app details are persisted and hydrated into the lead form.
  if (loggedInUser.email?.includes?.("@amber-temp.com")) {
    loggedInUser.email = "";
  }

  setLeadPersonalDetails(loggedInUser);
  dispatch(setLocalStorageData());
  return true;
};

export default syncAppLeadPersonalDetails;
